import { IKlantGroepModel } from 'shared/models/IKlantGroepModel'
import ActionButtons from './ActionButtons'
import OverviewTable from './OverviewTable'
import { IProductType } from 'shared/models/IProductType'
import { IOrderType } from 'shared/models/IOrderType'
import { FC } from 'react'

interface IProps {
  klantGroepen: IKlantGroepModel[]
  productTypes: { productType: IProductType; selected: boolean }[]
  possibleOrderTypes: IOrderType[]
  showDetails: (
    data: IKlantGroepModel,
    modifyingExistingRecord: boolean
  ) => void
  handleNieuw: (isdefault: boolean) => void
}

const ResultsSection: FC<IProps> = ({
  klantGroepen,
  productTypes,
  possibleOrderTypes,
  showDetails,
  handleNieuw,
}) => {
  if (!klantGroepen) return null

  return (
    <section>
      <OverviewTable
        klantGroepen={klantGroepen}
        productTypes={productTypes}
        possibleOrderTypes={possibleOrderTypes}
        showDetails={showDetails}
      />
      <ActionButtons handleNieuw={handleNieuw} />
    </section>
  )
}

export default ResultsSection
